/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from "@wordpress/element";
import { TextControl } from "@wordpress/components";
import { select } from "@wordpress/data";
import { doAction, applyFilters } from "@wordpress/hooks";

export default function DynamicInputControl(props) {
    const {
        label,
        attrName,
        inputValue,
        setAttributes,
        onChange,
        placeholder
    } = props;

    const [fieldValue, setFieldValue] = useState("");
    const [fieldPlaceholder, setFieldPlaceholder] = useState("");
    const [readOnly, setReadOnly] = useState(false);
    const [didMount, setDidMount] = useState(false);

    const dynamicTag = window?.EssentialBlocksProLocalize
        ? EssentialBlocksProLocalize.eb_dynamic_tags + "/"
        : "dynamic-tags/";

    useEffect(() => {
        setDidMount(true);
        if (inputValue && inputValue.startsWith(dynamicTag, 0)) {
            setReadOnly(true);
            setFieldPlaceholder(`[Dynamic Value]`);
        }
    }, []);

    useEffect(() => {
        if (didMount && EssentialBlocksProLocalize) {
            if (
                typeof fieldValue === "string" &&
                fieldValue.startsWith(dynamicTag, 0)
            ) {
                setReadOnly(true);
                setAttributes({ [attrName]: fieldValue });
                setFieldPlaceholder(`[Dynamic Value]`);
            } else {
                setReadOnly(false);
                setAttributes({ [attrName]: fieldValue });
            }
        }
    }, [fieldValue]);

    return (
        <div className="eb-dynamic-input-control">
            <TextControl
                label={__(label, "essential-blocks")}
                value={readOnly ? fieldPlaceholder : inputValue}
                placeholder={placeholder || ''}
                onChange={(text) => (readOnly ? false : onChange(text))}
                readOnly={readOnly}
            />
            {applyFilters(
                "essential_blocks_dynamic_input_control",
                "",
                fieldValue,
                setFieldValue,
                inputValue
            )}
        </div>
    );
}
